'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { Box, Typography } from '@mui/material'

// Types
import type { BenefitCardProps } from '@/types/components/molecules/home'

// Components
const MenuItemIconAtom = dynamic(() => import('@/components/atoms/icon/menu-item'))

// Photo with a short title and one line under it; the photo zooms slowly on hover
const BenefitCardMolecule = (props: BenefitCardProps) => {
	// Props
	const { icon, title, description, image, href } = props

	return (
		<Box
			component={Link}
			href={href}
			draggable={false}
			sx={{
				display: 'block',
				color: 'text.primary',
				'&:hover img': { transform: 'scale(1.06)' },
				'&:hover .benefit-title': { color: 'primary.main' }
			}}
		>
			<Box sx={{ position: 'relative', height: { xs: 300, md: 340 }, borderRadius: 5, overflow: 'hidden', bgcolor: 'grey.200' }}>
				<Image
					src={image}
					alt={title}
					fill
					draggable={false}
					// Lazy so the photos don't compete with the first paint; the browser still loads each one as the moving row brings it near the screen
					loading="lazy"
					sizes="(max-width: 900px) 70vw, 300px"
					style={{ objectFit: 'cover', transition: 'transform 1s cubic-bezier(0.22, 1, 0.36, 1)' }}
				/>
			</Box>

			<Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main', '& .MuiSvgIcon-root': { fontSize: 20 } }}>
				<MenuItemIconAtom name={icon} />

				<Typography className="benefit-title" component="h3" sx={{ fontSize: 17, fontWeight: 700, color: 'text.primary', transition: 'color .3s' }}>
					{title}
				</Typography>
			</Box>

			<Typography sx={{ mt: 0.5, fontSize: 14, lineHeight: 1.8, color: 'text.secondary' }}>{description}</Typography>
		</Box>
	)
}

export default BenefitCardMolecule
